<div
	class="card"
	[ngClass]="{ 'card--pressed': isPressed, 'card--disabled': disabled }"
	[class.pressed]="isPressed"
	(mousedown)="isPressed = true"
	(mouseup)="isPressed = false"
	(mouseleave)="isPressed = false"
	(touchstart)="isPressed = true; $event.stopPropagation()"
	(touchend)="isPressed = false; $event.stopPropagation()"
	type="button"
	[attr.disabled]="disabled ? true : null"
>
	<i *ngIf="icon" [ngClass]="iconClasses"></i>
	<div class="card__text">
		<h3 *ngIf="label">{{ label }}</h3>
		<span *ngIf="description">{{ description }}</span>
		<ng-content></ng-content>
	</div>
</div>
